import { render, staticRenderFns } from "./CurrentPassword.vue?vue&type=template&id=37a4a3f8&scoped=true&"
import script from "./CurrentPassword.vue?vue&type=script&lang=js&"
export * from "./CurrentPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a4a3f8",
  null
  
)

export default component.exports